"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TourFacilitatorUser {
}
exports.TourFacilitatorUser = TourFacilitatorUser;
